import { useMutation } from '@tanstack/react-query';
import * as onboardingService from '../services/onboardingService';

// APPROVE AI SUMMARY
export const useApproveAISummary = () =>
  useMutation({
    mutationFn: (id: string) => onboardingService.approveAISummary(id),
  });
